// The scene's points of interest that belong to a model: where he stands
// to use a want, and at the rack, and where he sleeps in each roost (the
// four containers and the tube carriage, `roost` says which). Read off the
// models' own stand empties and the rest markers in Kiwi_world.blend by
// scripts/blender/wants-sync.py, so a model moved there takes its spot
// with it; lib/world/sceneConfig.js adds these to the rest.
//
// Generated: edit the blend and regenerate rather than this file.
//
// Imports nothing.

export const MODEL_POIS = [
  { id: 'poi_wishBench', name: 'wishBench', position: [-13.89, 0.0, 1.56] },
  { id: 'poi_wishMarket', name: 'wishMarket', position: [-75.51, 0.0, 44.08] },
  { id: 'poi_rack', name: 'rack', position: [23.23, 0.0, -53.23] },
  { id: 'poi_wishShelter', name: 'wishShelter', position: [-5.92, 0.0, 28.94] },
  { id: 'poi_eatSoup', name: 'eatSoup', position: [81.71, 0.0, 35.33] },
  { id: 'poi_wishVending', name: 'wishVending', position: [111.5, 0.0, 24.55] },
  { id: 'poi_wishKeys', name: 'wishKeys', position: [-22.6, 0.0, -54.35] },
  { id: 'poi_tagging_07', name: 'tagging_07', position: [53.05, 0.0, 22.0] },
  { id: 'poi_rest', name: 'rest', position: [-26.28, 0.0, -8.98], roost: 'container' },
  { id: 'poi_rest_2', name: 'rest_2', position: [67.06, 0.0, 53.42], roost: 'container' },
  { id: 'poi_rest_3', name: 'rest_3', position: [103.92, 0.0, -8.99], roost: 'container' },
  { id: 'poi_rest_4', name: 'rest_4', position: [-18.19, 0.0, -92.51], roost: 'container' },
  { id: 'poi_rest_5', name: 'rest_5', position: [95.23, 0.0, -81.8], roost: 'carriage' },
]
